






































































import {Component, Vue} from 'vue-property-decorator';
import {mapGetters} from "vuex";
import CompanyAnnouncements from "@/components/company/CompanyAnnouncements.vue";
import CompanyWorkers from "@/components/company/CompanyWorkers.vue";
import Mappa from "@/components/Mappa.vue";
import CompanyWorker from "@/components/company/CompanyWorker.vue";
import EventBus from "@/EventBus";

@Component({
    components: {
        CompanyAnnouncements,
        CompanyWorkers,
        Mappa,
        CompanyWorker
    },
    computed: {
        ...mapGetters({user: 'user', profile: 'profile', isCompany: 'isCompany', workers: 'workers'})
    },
    name: "CompanyDashboard"
})
export default class CompanyDashboard extends Vue {
    private user?: any;
    private profile?: any;
    private workers?: any[];
    private tab_index: number = 0;
    private filterAnnouncementSettore: any | null = null
    private showing_action_id:string = '';
    private tabsOffset: number[] = [0,0,0];

    get tabIndex(){
        return this.tab_index;
    }

    set tabIndex(val:number){
        this.showAction = '';
        this.tab_index = val;
        EventBus.$emit('ca:menu_close');
        EventBus.$emit('cw:menu_close');
        EventBus.$emit('wa:menu_close');
    }

    get showAction(){
        return this.showing_action_id;
    }
    set showAction(val:string){
        this.showing_action_id = val
    }

    get starredWorkersIds() {
        return this.profile?.starredWorkers || [];
    }

    get starredWorkers() {
        return (this.workers as any[]).filter(item => {
            return this.starredWorkersIds.indexOf(item.id) > -1
        })
    }

    setFilteredAnnouncement(ann: any) {
        this.filterAnnouncementSettore = ann
        this.tabIndex = 1;
    }

    updated() {
        this.$nextTick(() => {
            (this.$refs.innerMap as any).invalidateMap()
        })
    }

    private deactivated(){
        // @ts-ignore
        this.tabsOffset = [...document.getElementsByClassName('tab-pane')].map((el: any)=>{
            return el.scrollTop;
        });
    }

    private activated(){
        // @ts-ignore
        [...document.getElementsByClassName('tab-pane')].forEach((el: any, index:  number)=>{
            el.scrollTop = this.tabsOffset[index];
        });
    }
}

